import { useMutation } from '@tanstack/react-query';

import * as service from '../services';
import { useAderenciaPrecosStore } from '../AderenciaPrecos.store';
import type { FileDownloadStatusType } from '../types';

export const useAderenciaCounter = () => {
  const { setAderenciaPrecosState } = useAderenciaPrecosStore();
  const handleDetailsDownload = async () => {
    const { detailsDownloadType, aderenciaDetailsBodyRequest } = useAderenciaPrecosStore.getState();
    const { size: _size, ...body } = aderenciaDetailsBodyRequest;
    await service.aderenciaDetailsDownload(detailsDownloadType, body);
  };

  const getCounter = async () => {
    const { dataInicial, dataFinal, page, size, ...bodyRequest } = useAderenciaPrecosStore.getState().aderenciaDetailsBodyRequest;
    const resp = await service.getAderenciaDetailsCount(bodyRequest);
    return resp;
  };

  const showDownloadModal = (statusType: FileDownloadStatusType) => {
    setAderenciaPrecosState('showModalDetailsDownload', true);
    setAderenciaPrecosState('fileDownloadStatusType', statusType);
  };

  const successAction = (data: { data: number }) => {
    const count = data.data;

    if (count === 0) return showDownloadModal('noDataForDownload');
    if (count > 1_000_000) return showDownloadModal('willNotDownload');
    if (count > 50_000) {
      void handleDetailsDownload();
      return showDownloadModal('willReceiveByEmail');
    }

    void handleDetailsDownload();
  };

  const mutate = useMutation({
    mutationFn: getCounter,
    onSuccess: successAction,
  });

  return {
    handleGetAderenciaDetailsCount: mutate.mutateAsync,
  };
};
